// Package Imports
import React from 'react';
import '@refinedev/antd/dist/reset.css';

// Project Imports
import 'App.css';
import Initiate from 'Initiate';
import { useTokenContext } from 'contexts/resource/ResourceContext';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Components } from 'react-formio';
import FormioCustomComponent from 'components/modules/formio-custom-components-package/custom';
import Loading from 'components/loading/loading';

Components.setComponents(FormioCustomComponent);

const App = () => {
  const { loading } = useTokenContext();

  if (loading) {
    return <Loading />;
  }
  return <Initiate />;
};

export default App;
